import React from 'react'
import PropTypes from 'prop-types'
import { ReactComponent as LeftArrow } from '@assets/svgs/icons/left_arrow.svg'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import Link from 'gatsby-link'
import './BackLink.module.scss'

const BackLink = ({ text, to, anchor }) => {
  const LinkTo = anchor ? AnchorLink : Link

  return (
    <LinkTo offset='80' href={to} to={to} styleName='link'>
      <LeftArrow />
      <span>{text}</span>
    </LinkTo>
  )
}

BackLink.propTypes = {
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired
}

export default BackLink



// WEBPACK FOOTER //
// ./src/components/BackLink/BackLink.js